/**
 * Shared color utilities for participant colors
 */

/**
 * Generate a consistent color for each participant
 * Uses a fixed color array to ensure consistency across all components
 */
export const getParticipantColor = (participantId: string): string => {
  const colors = [
    '#3b82f6', // blue
    '#ef4444', // red
    '#10b981', // green
    '#f59e0b', // yellow
    '#8b5cf6', // purple
    '#06b6d4', // cyan
    '#f97316', // orange
    '#ec4899', // pink
  ];
  const index = participantId.charCodeAt(0) % colors.length;
  return colors[index];
};
